import React, { useEffect, useState } from 'react';

import StoriesViewerAndroid, {
  Story,
} from 'pages/Stories/StoriesViewerAndroid';
import StoriesViewerIOS from 'pages/Stories/StoriesViewerIOS';
import { get } from 'lib/api';
import CustomLoader from 'designSystem/components/ui/Loader';

import * as Styles from './styles';

const Stories = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [storyData, setStoryData] = useState<Story[]>([]);
  const origin = localStorage.getItem('app_origin');

  useEffect(() => {
    async function fetchStories() {
      try {
        setIsLoading(true);
        const response = await get(
          '/campaigns/info?name=ListnerWritingNudgeBannerGTM'
        );
        const { data } = response;
        if (!data || !Array.isArray(data)) {
          throw new Error('Invalid data format');
        }
        setStoryData(data);
      } catch (error) {
        console.error('Error fetching stories', error);
      } finally {
        setIsLoading(false);
      }
    }

    fetchStories();
  }, []);

  function closeIos() {
    alert('closeIos function called');
    if (window.webkit) {
      alert('window  webkit');
      console.log('window  webkit');
      if (
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.closePage
      ) {
        alert('close webkit.messageHandlers');

        console.log('close webkit.messageHandlers');
        window.webkit.messageHandlers.closePage.postMessage();
      }
      if (
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.writerBackPressed
      ) {
        alert('writerBackPressed webkit.messageHandlers');
        console.log('writerBackPressed webkit.messageHandlers');
        window.webkit.messageHandlers.writerBackPressed.postMessage(
          'writerBackPressed'
        );
      }
    }
  }

  return (
    <Styles.AppContainer>
      {isLoading ? (
        <CustomLoader />
      ) : (
        <>
          {storyData.length > 0 && (
            <div>
              {origin === 'pfm_android' ? (
                <StoriesViewerAndroid stories={storyData} />
              ) : (
                <StoriesViewerIOS stories={storyData} closeIos={closeIos} />
              )}
            </div>
          )}
        </>
      )}
    </Styles.AppContainer>
  );
};

export default Stories;
